import * as actionTypes from './../actions/actionTypes';
import ResponseErrorMessages from '@/modules/casino/store/errors/ResponseErrorMessages.js';

const realInitialState = {
  errors: {
    phone: undefined,
    email: undefined,
    password: undefined,
    otp: undefined,
    global: undefined,
    username: undefined,
  },
  SMSType: undefined,
  signedUp: undefined,
  signedUpErrors: undefined,
  signUpLoading: false,

  partialAccount: {
    loading: false,
    error: false,
    errorCode: undefined,
    errorMessage: undefined,
    existingAccount: false,
    existingAccountData: {
      // email: undefined,
      phone: undefined,
      phone_country_code: undefined,
    },
  },
};

const initialState = realInitialState;

const reducer = (state = initialState, action: any) => {
  switch (action.type) {
    case actionTypes.register.SET_REGISTER_SIGNUP_LOADING:
      return {
        ...state,
        signUpLoading: action.data ?? false,
        // signedUp: undefined, // reset signedUp when loading
      };

    case actionTypes.register.VALIDATE_FIELD_RESPONSE:
      console.log('DEBUG VALIDATE_FIELD_RESPONSE REDUCER: ', action);

      const errors: any = { ...state.errors };
      if (action.field === 'username') {
        errors[action.field] = action?.message?.exists ? 'REGISTER.USERNAME_ALREADY_EXISTS_ERROR' : undefined;
      } else {
        errors[action.field] = action.message;
      }

      return {
        ...state,
        errors: errors,
      };
    case actionTypes.register.SET_PARTIAL_ACCOUNT:
      return {
        ...state,
        partialAccount: {
          ...state.partialAccount,
          loading: true,
        },
      };

    case actionTypes.register.PARTIAL_ACCOUNT_RESPONSE:
      // console.log('DEBUG PARTIAL_ACCOUNT_RESPONSE REDUCER: ', action);

      return {
        ...state,
        partialAccount: {
          ...state.partialAccount,
          loading: false,
          error: !action.data.success,
          errorCode: action.data.errorCode ?? undefined,
          errorMessage: action.data.errorMessage
            ? action.data.errorMessage
            : action.data.errorCode
              ? ResponseErrorMessages.get(action.data.errorCode)
              : undefined,
          existingAccount: action.data.existingAccount ?? false,
          existingAccountData: {
            phone: action.data.existingAccountData?.phone ?? undefined,
            phone_country_code: action.data.existingAccountData?.phone_country_code ?? undefined,
          },
        },
      };
    case actionTypes.register.RESET_REGISTER:
      return {
        ...realInitialState,
        partialAccount: {
          ...realInitialState.partialAccount,
          existingAccount: state.partialAccount.existingAccount,
        },
      };

    case actionTypes.register.RESET_REGISTER_PARTIAL_ACCOUNT_DATA:
      return {
        ...state,
        partialAccount: {
          ...realInitialState.partialAccount,
        },
      };
    case actionTypes.register.RESET_REGISTER_GLOBAL_ERROR:
      // console.log('DEBUG RESET_REGISTER_GLOBAL_ERROR REDUCER: ', action);

      return {
        ...state,
        errors: {
          ...state.errors,
          global: undefined,
        },
      };

    case actionTypes.register.SEND_REGISTER_SMS_RESPONSE:
      let verifyPhoneError: any = undefined;
      if (typeof action.data.ResponseCode !== 'undefined') {
        if (typeof action.data.ResponseMessage === 'string') {
          verifyPhoneError = action.data.ResponseMessage;
        } else {
          verifyPhoneError = ResponseErrorMessages.get(action.data.ResponseCode);
        }
      }

      return {
        ...state,
        loading: false,
        SMSType: action.data.type ?? undefined,
        errors: {
          ...state.errors,
          otp: verifyPhoneError,
          // global: verifyPhoneError,
          phone: verifyPhoneError,
        },
      };

    case actionTypes.register.REGISTER_RESPONSE:
      let signedUp = true;
      let signedUpErrors: any = undefined;
      let parsedSignUpErrorCode: any = undefined;
      const newErrors: { [key: string]: any } = {};
      let parsedSignUpErr = undefined;

      console.log('DEBUG [REGISTER_RESPONSE] REDUCER ACTION:', action);

      if (typeof action.errors !== 'undefined') {
        if (action.errors && Array.isArray(action.errors) && action.errors.length === 0) {
          return {
            ...state,
            signUpLoading: false,
            signedUp: true,
            errors: {
              ...state.errors,
              global: undefined,
            },
          };
        }

        // case when we have a response code
        if (typeof action.errors.ResponseCode !== 'undefined') {
          // if is string
          signedUp = false;
          signedUpErrors = ResponseErrorMessages.get(action.errors.ResponseCode);
          parsedSignUpErrorCode = action.errors.ResponseCode;
        } else {
          // case when we have a validation message
          // if it`s an apiagility error (fields that are required)
          if (typeof action.errors.validation_messages !== 'undefined') {
            signedUp = false;
            signedUpErrors = action.errors.validation_messages;

            // set each key in errors
            if (typeof signedUpErrors === 'object') {
              const keys = Object.keys(signedUpErrors);
              if (keys.length > 0) {
                keys.forEach((key) => {
                  if (typeof key === 'string') newErrors[key] = `Invalid value for ${key}`;
                });
              }
            }

            return {
              ...state,
              signUpLoading: false,
              signedUp: signedUp,
              errors: {
                ...state.errors,
                ...newErrors,
              },
            };
          } else {
            // if is core error
            if (typeof action.errors.errors !== 'undefined') {
              signedUp = false;
              signedUpErrors = action.errors.errors[0];
              if (typeof signedUpErrors[1] !== 'undefined') {
                signedUpErrors = signedUpErrors[1];
              } else {
                // check if obj
                if (typeof signedUpErrors === 'object') {
                  signedUpErrors = Object.values(signedUpErrors).join(' , ');
                }
              }
            }

            if (action.errors && Array.isArray(action.errors) && action.errors.length > 0) {
              signedUp = false;
              const er = action.errors[0];
              // check if signedUpErrors is an object and if yes, get the first value
              if (typeof er === 'object') {
                signedUpErrors = Object.values(er)[0];
                parsedSignUpErrorCode = Object.keys(er)[0];
              }
            }
          }
        }

        parsedSignUpErr = ResponseErrorMessages.getParsedRegisterError(parsedSignUpErrorCode);
      } else {
        signedUp = action.value;
        if (!signedUp) {
          signedUpErrors = 'unknown sign up error';
          parsedSignUpErr = ResponseErrorMessages.getParsedRegisterError(1);
        }
      }

      return {
        ...state,
        signUpLoading: false,
        signedUp: signedUp,
        errors: {
          ...state.errors,
          // global: signedUpErrors,
          global: parsedSignUpErr,
        },
      };

    default:
      return state;
  }
};

export default reducer;
